import React from 'react'
import '../CSS/typeOfTest.css'
import Button from "@material-tailwind/react/Button";
import { Link } from 'react-router-dom'
import NavOnlyIcons from './NavOnlyIcons';
import SubFooter from './SubFooter';

const TypesOfTest = () => {
    return (
    <>
        <div className="typeOfTestMain">
            <div className="dipNav">
                <NavOnlyIcons /> 
            </div>
            <div className="depressionInnerDiv2">
            <div className="depressionInnerDiv2Top">
                <div className="depressionInnerDiv2Left">
                    <h2>Discover Yourself</h2>
                    <p>Take our short online test to find out if you’re living 
                        with depression.Take our short online test to find out if you’re living 
                        with depression.</p>
                </div>
        
                <div className="depressionInnerDiv2Right">
                
                </div>
            </div>
                
                    <div className="testType" id="testType1">
                        <img src='https://www.verywellfamily.com/thmb/u7EqpJqEZaCeUH1--RTWSgiaWLk=/500x350/filters:no_upscale():max_bytes(150000):strip_icc()/GettyImages-164413895-56a258cb5f9b58b7d0c9336c.jpg' alt="testImg" />
                        <div className="testTypeContext">
                            <h2 className="testTypeHead">This is Test Type</h2>
                            <small>Take our short online test to find out if you’re living 
                            with depression.</small>
                            <Link to='/depression_test'>
                                <Button color="lightBlue" size="lg" ripple="light">Begin Test</Button>
                            </Link>
                        </div>
                    </div>
                    
                    <div className="typesOfTest">
                        

                        <div className="testType" id="testType2">
                            <img src='https://img.freepik.com/free-photo/lonely-depressed-person-sitting-near-brick-wall_181624-30778.jpg?size=626&ext=jpg' alt="testImg" />
                            <div className="testTypeContext">
                                <h2 className="testTypeHead">This is Test Type</h2>
                                <small>Take our short online test to find out if you’re living 
                                with depression.</small>
                                <Link to='/depression_test'>
                                    <Button color="lightBlue" size="lg" ripple="light">Begin Test</Button>
                                </Link>
                            </div>
                        </div>

                        <div className="testType" id="testType3">
                            <img src='https://t4.ftcdn.net/jpg/01/72/07/45/360_F_172074594_eXz9gGgHIoxdd8QK4dgmwNjCbwSSVSv0.jpg' alt="testImg" />
                            <div className="testTypeContext">
                                <h2 className="testTypeHead">This is Test Type</h2>
                                <small>Take our short online test to find out if you’re living 
                                with depression.</small>
                                <Link to='/depression_test'>
                                    <Button color="lightBlue" size="lg" ripple="light">Begin Test</Button>
                                </Link>
                            </div>
                        </div>

                        <div className="testType" id="testType4">
                            <img src='https://emeraldpsychiatry.com/wp-content/uploads/2019/02/Signs-of-Depression-Min-Emerald-Psych.jpg' alt="testImg" />
                            <div className="testTypeContext">
                                <h2 className="testTypeHead">This is Test Type</h2>
                                <small>Take our short online test to find out if you’re living 
                                with depression.</small>
                                <Link to='/depression_test'>
                                    <Button color="lightBlue" size="lg" ripple="light">Begin Test</Button>
                                </Link>
                            </div>
                        </div>

                        <div className="testType" id="testType5">
                            <img src='https://ranchatdovetree.com/wp-content/uploads/2020/07/Addiction-and-Depression-How-High-Stress-Times-Put-You-at-Risk.jpg' alt="testImg" />
                            <div className="testTypeContext">
                                <h2 className="testTypeHead">This is Test Type</h2>
                                <small>Take our short online test to find out if you’re living 
                                with depression.</small>
                                <Link to='/depression_test'>
                                    <Button color="lightBlue" size="lg" ripple="light">Begin Test</Button>
                                </Link>
                            </div>
                        </div>

                        <div className="testType" id="testType6">
                            <img src='https://www.verywellfamily.com/thmb/u7EqpJqEZaCeUH1--RTWSgiaWLk=/500x350/filters:no_upscale():max_bytes(150000):strip_icc()/GettyImages-164413895-56a258cb5f9b58b7d0c9336c.jpg' alt="testImg" />
                            <div className="testTypeContext">
                                <h2 className="testTypeHead">This is Test Type</h2>
                                <small>Take our short online test to find out if you’re living 
                                with depression.</small>
                                <Link to='/depression_test'>
                                    <Button color="lightBlue" size="lg" ripple="light">Begin Test</Button>
                                </Link>
                            </div>
                        </div>

                        <div className="testType" id="testType6">
                            <img src='https://ranchatdovetree.com/wp-content/uploads/2020/07/Addiction-and-Depression-How-High-Stress-Times-Put-You-at-Risk.jpg'  alt="testImg" />
                            <div className="testTypeContext">
                                <h2 className="testTypeHead">This is Test Type</h2>
                                <small>Take our short online test to find out if you’re living 
                                with depression.</small>
                                <Link to='/depression_test'>
                                    <Button color="lightBlue" size="lg" ripple="light">Begin Test</Button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
           
        </div>
        <SubFooter /> 
    </>
    )
}

export default TypesOfTest
